(function () {
  const isVariantsPreOrderInsteadOos = () =>
    window.variantsPreOrderInsteadOos === true ||
    document.querySelector('[data-variants-pre-order-instead-oos="true"]') !=
      null;

  const getPreOrderBadgeText = () => {
    if (typeof preorderBadgeText === 'string' && preorderBadgeText) {
      return preorderBadgeText;
    }
    if (
      typeof window.preorderBadgeText === 'string' &&
      window.preorderBadgeText
    ) {
      return window.preorderBadgeText;
    }
    return 'Pre-order';
  };

  const getCheckedSizeInput = () =>
    document.querySelector('.size_option_input .size_slider input:checked');

  const isInputQtyPreOrder = input => {
    if (!(input instanceof HTMLInputElement)) return false;
    if (input.dataset.preOrder !== undefined) {
      return input.dataset.preOrder === 'true';
    }
    if (!isVariantsPreOrderInsteadOos()) return false;
    if (input.dataset.inventoryPolicy !== 'continue') return false;
    const qty = Number(input.dataset.inventoryQuantity);
    return Number.isFinite(qty) && qty <= 0;
  };

  function updateSizeLabel(input) {
    const label = document.querySelector(`label[for="${input.id}"]`);

    const sizeWrapper = input.closest('.size_option_input');
    if (!sizeWrapper) return;

    const sizeValueElement = sizeWrapper.querySelector('.size-value');
    if (!sizeValueElement || !label) return;

    const labelText = label.textContent.trim();
    const isPurchaseAvailable = input.dataset.available !== 'false';
    const showSizeOnly = isPurchaseAvailable || isInputQtyPreOrder(input);

    sizeValueElement.textContent = showSizeOnly
      ? labelText
      : `${labelText} · ${outOfStockGlobalVariable}`;
  }

  function syncVariantsPreOrderBadge(forcePreOrder) {
    const badgeSections = document.querySelectorAll('[data-badge-section]');
    if (!badgeSections.length) return;

    const checked = getCheckedSizeInput();
    const isPreOrder =
      typeof forcePreOrder === 'boolean'
        ? forcePreOrder
        : isInputQtyPreOrder(checked);
    const shouldShow =
      isVariantsPreOrderInsteadOos() &&
      isPreOrder &&
      window.productBadgePreOrder !== true;

    badgeSections.forEach(section => {
      const existing = section.querySelector('[data-variants-pre-order-badge]');

      if (!shouldShow) {
        existing?.remove();
        return;
      }

      if (existing) return;

      const referenceBadge = section.querySelector(
        '.selling-badge:not([data-variants-pre-order-badge])'
      );
      const badge = document.createElement('div');
      // tw-static keeps the injected badge in the flow when it lands inside
      // .badges-list-wrapper, where the container's direct-child rule does not reach it.
      badge.className = referenceBadge
        ? referenceBadge.className
        : 'selling-badge tw-static selling-badge--variants-pre-order';
      badge.dataset.handle = 'pre-order';
      badge.dataset.available = 'true';
      badge.dataset.sale = 'false';
      badge.setAttribute('data-variants-pre-order-badge', '');
      const span = document.createElement('span');
      span.textContent = getPreOrderBadgeText();
      badge.appendChild(span);

      const listWrapper = section.querySelector('.badges-list-wrapper');
      if (listWrapper) {
        listWrapper.append(badge);
      } else {
        section.append(badge);
      }
    });
  }

  const getOutOfStockBadgeText = () => {
    if (
      typeof outOfStockGlobalVariable === 'string' &&
      outOfStockGlobalVariable
    ) {
      return outOfStockGlobalVariable;
    }
    if (
      typeof window.outOfStockGlobalVariable === 'string' &&
      window.outOfStockGlobalVariable
    ) {
      return window.outOfStockGlobalVariable;
    }
    return 'Out of stock';
  };

  // Colours live in .selling-badge--oos; the layout classes are borrowed from a badge that
  // is already positioned in this section, minus its own colour modifier.
  function createOosBadge(reference) {
    const layoutClasses = reference
      ? reference.className.replace(/selling-badge--[\w-]+/g, '').trim()
      : 'selling-badge tw-static';
    const badge = document.createElement('div');
    badge.className = `${layoutClasses} selling-badge--oos`;
    badge.dataset.handle = 'oos';
    badge.setAttribute('data-variant-oos-badge', '');
    const span = document.createElement('span');
    span.textContent = getOutOfStockBadgeText();
    badge.appendChild(span);
    return badge;
  }

  const hideBadgeForVariant = badge => {
    badge.dataset.oosHidden = 'true';
    badge.style.setProperty('display', 'none', 'important');
  };

  const restoreBadgeForVariant = badge => {
    if (badge.dataset.oosHidden === undefined) return;
    delete badge.dataset.oosHidden;
    badge.style.removeProperty('display');
  };

  // An out-of-stock variant shows Out of stock on its own: every other badge is hidden, and
  // the badge is created when the product carries none of its own. A pre-order variant keeps
  // its own badge and drops Few items left, since the two must never show together.
  // Accepts the size input or ready-made flags, like syncVariantsPreOrderBadge —
  // renderProductInfo in global.js replaces the badge markup on every variant change and
  // calls back with the flags it already computed.
  function syncVariantOosBadge(source, forcePreOrder) {
    let isSoldOut;
    let isPreOrder;
    if (typeof source === 'boolean') {
      isSoldOut = source;
      isPreOrder = forcePreOrder === true;
    } else {
      const checked =
        source instanceof HTMLInputElement ? source : getCheckedSizeInput();
      isPreOrder = isInputQtyPreOrder(checked);
      isSoldOut =
        checked instanceof HTMLInputElement &&
        checked.dataset.available === 'false' &&
        !isPreOrder;
    }

    document.querySelectorAll('[data-badge-section]').forEach(section => {
      const injected = section.querySelector('[data-variant-oos-badge]');
      const own = [...section.querySelectorAll('.selling-badge')].filter(
        badge => !badge.hasAttribute('data-variant-oos-badge')
      );

      if (!isSoldOut) {
        injected?.remove();
        own.forEach(badge => {
          if (isPreOrder && badge.dataset.handle === 'few-items-left') {
            hideBadgeForVariant(badge);
            return;
          }
          restoreBadgeForVariant(badge);
        });
        return;
      }

      // A whole-product OOS badge is already rendered server-side, reuse it instead of stacking.
      const serverOos = own.find(badge => badge.dataset.handle === 'oos');

      own.forEach(badge => {
        if (badge === serverOos) return;
        hideBadgeForVariant(badge);
      });

      if (serverOos || injected) return;
      const host = section.querySelector('.badges-list-wrapper') || section;
      host.append(createOosBadge(own[0]));
    });
  }

  window.syncVariantsPreOrderBadge = syncVariantsPreOrderBadge;
  window.syncVariantOosBadge = syncVariantOosBadge;
  window.isVariantQtyPreOrder = isInputQtyPreOrder;

  function attachVariantChangeHandler() {
    document.addEventListener('change', event => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;

      if (target.closest('.size_option_input .size_slider')) {
        updateSizeLabel(target);
        syncVariantsPreOrderBadge(isInputQtyPreOrder(target));
        syncVariantOosBadge(target);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (window.initStampedReviews) {
      window.initStampedReviews({ scopeSelector: '.main-pdp-new' });
    }

    const checked = getCheckedSizeInput();

    if (checked instanceof HTMLInputElement) {
      updateSizeLabel(checked);
      syncVariantsPreOrderBadge(isInputQtyPreOrder(checked));
      syncVariantOosBadge(checked);
    }

    attachVariantChangeHandler();
  });
})();
